"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var vue_1 = require("vue");
var vuex_1 = require("vuex");
var login_store_1 = require("./login.store");
var user_store_1 = require("./user.store");
var layout_store_1 = require("./layout.store");
var campaign_store_1 = require("./campaign.store");
vue_1.default.use(vuex_1.default);
exports.store = new vuex_1.default.Store({
    modules: {
        login: login_store_1.loginModule,
        user: user_store_1.userModule,
        layout: layout_store_1.layoutModule,
        campaign: campaign_store_1.campaignModule
    }
});
